import {
  CalendarGranularity,
  CalendarMetric,
  CalendarMode,
  CalendarModeData,
  CalendarModeInitialData,
  CalendarView,
  WorkforceMetricsMode
} from "PFApp/booking/types";
import { ProjectsResponse } from "PFCore/hooks/queries/bookings/projects/use_projects_entries";
import { WorkforceResponse } from "PFCore/hooks/queries/bookings/workforce/use_workforce_entries";
import { Threshold } from "PFTypes";
import React, { SetStateAction } from "react";

export type WorkforceCalendarData = {
  thresholds: Record<string, Threshold[]>;
  calendarGranularity: CalendarGranularity;
  setCalendarGranularity: React.Dispatch<SetStateAction<CalendarGranularity>>;
};

export type ProjectsCalendarData = {
  childrenFiltersEnabled: boolean;
  setChildrenFiltersEnabled: React.Dispatch<SetStateAction<boolean>>;
};

export enum SettingsOptions {
  WorkWeek = "workWeek"
}

export type BookingCalendarData<
  T = WorkforceCalendarData | ProjectsCalendarData,
  Response extends ProjectsResponse | WorkforceResponse = ProjectsResponse | WorkforceResponse
> = {
  view: CalendarView;
  setView: (view?: CalendarView, initialData?: Omit<CalendarModeInitialData, "view">) => void;
  metric: CalendarMetric;
  setMetric: React.Dispatch<SetStateAction<CalendarMetric>>;
  page: number;
  setPage: React.Dispatch<SetStateAction<number>>;
} & CalendarModeData<Response> &
  T;

export type BookingsOverviewContextType<T extends WorkforceCalendarData | {}> = {
  calendarMode: CalendarMode;
  setCalendarMode: (mode: CalendarMode, initialData?: CalendarModeInitialData) => void;
  workWeekEnabled: boolean;
  setWorkWeekEnabled: React.Dispatch<SetStateAction<boolean>>;
  calendarData: BookingCalendarData<T>;
  showUtilizationMetrics: boolean;
  workforceMetricsMode: WorkforceMetricsMode;
  setWorkforceMetricsMode: React.Dispatch<SetStateAction<WorkforceMetricsMode>>;
};
